"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.appendQueryParams = appendQueryParams;
exports.removeQueryParams = removeQueryParams;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
// Unlike URL and URLSearchParams these will respect use of trailing slashes
// and query param flags (keys without "=" values). Also order is preserved.

function disassemble(url) {
  const [protoPath, searchAndHash] = url.split('?');
  const [search, hash] = (searchAndHash || '').split('#');

  // build key values
  const params = []; // array because keys can be repeated
  if (search) {
    for (let pair of search.split('&')) {
      const [key, val] = pair.split('=');
      params.push([key, val]);
    }
  }
  // hash could be in protoPath
  return {
    protoPath,
    params,
    hash
  };
}
function assemble(protoPath, params, hash) {
  let newSearch = [];
  for (let [key, val] of params) {
    if (val === undefined) {
      newSearch.push(key);
    } else {
      newSearch.push(`${key}=${val}`);
    }
  }
  const search = newSearch.length ? '?' + newSearch.join('&') : '';
  hash = hash ? '#' + hash : '';
  return `${protoPath}${search}${hash}`;
}
function removeQueryParams(url, keys) {
  const {
    protoPath,
    params,
    hash
  } = disassemble(url);

  // build whitelisted key values
  keys = new _set.default(keys);
  const newParams = (0, _filter.default)(params).call(params, ([key]) => !keys.has(key));

  // reassemble
  return assemble(protoPath, newParams, hash);
}
function appendQueryParams(url, keyValPairs) {
  const {
    protoPath,
    params,
    hash
  } = disassemble(url);
  const newParams = [...params, ...keyValPairs];
  return assemble(protoPath, newParams, hash);
}